// src/axiosSetup.js
import axios from "axios";
import { clearAuth } from "./auth";

let API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000/api";

// Prevent /api/api duplication
if (window.location.pathname.startsWith("/api")) {
  API_BASE_URL = "http://localhost:3000/api";
}

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Content-Type"] = "application/json";

export const attachAuthInterceptors = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      config.withCredentials = true;
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const message = error.response?.data?.message?.toLowerCase() || "";
      const tokenAuthMessages = [
        "missing authentication token",
        "invalid authentication token payload",
        "invalid authentication token",
        "authentication token expired",
        "invalid token payload",
      ];
      const hasTokenValidationMessage =
        tokenAuthMessages.some((msg) => message.includes(msg)) ||
        message.includes("token") ||
        message.includes("jwt") ||
        message.includes("bearer") ||
        message.includes("authentication") ||
        message.includes("unauthorized") ||
        message.includes("expired");
      const skipRedirect =
        error.config?.headers?.["x-skip-auth-redirect"] === true;

      if (status === 401 && message.includes("password")) {
        return Promise.reject(error);
      }

      if (skipRedirect) {
        return Promise.reject(error);
      }

      if (status === 401 && hasTokenValidationMessage) {
        clearAuth();
        window.location.replace("/session-timeout");
        return Promise.reject(error);
      }

      if (status === 403) {
        clearAuth();
        window.location.replace("/login");
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

// ======================================================
// REQUEST INTERCEPTOR → ATTACH TOKEN
// ======================================================
attachAuthInterceptors(axios);

export default axios;
